import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import S3FileUpload from 'react-s3'
import { debounce } from 'lodash'

// antd
import {
    Card,
    Checkbox,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Empty,
    Form,
    Image,
    Input,
    Row,
    Select,
    Space,
    Spin,
    Tag,
    Typography,
    Upload,
    message,
    theme,
} from 'antd'

// slices
import {
    addSummary,
    changeModel,
    checkButtonType,
    masterDataAddDropDown,
    masterDataDropDownList,
    profileLoading,
    profileState,
    switchProfileModal,
    updateUserGet,
} from '../profile.slice'
import { loginState } from '../../login/login.slice'

// components
// import SelectTags from '../../../components/selectTags'
import Button from '../../../components/button/button'
import ModalProfile from '../../../components/modal'
import DropDownMultiple from '../../../components/dropDownMultiple'

// modal
import ViewMediaModal from './viewMediaModal'

// helpers
import { isEmpty } from '../../../helpers/fieldCheck'

// constants
import { MASTER_DATA_FIELD } from '../../../constants/masterData'

// assets
import {
    CompanyDefaultIcon,
    CrossIcon,
    ExpandIcon,
    ExperienceIcon,
    PreviewIcon,
    SkillsIcon,
    ToolsIcon,
    VideosIcon,
} from '../../../assets/icons'

// styles
import styles from '../profile.module.css'

import dayjs from 'dayjs'
import { candidateEdit } from '../../candidate/store/candidate.slice'

function ExperienceModal({ modalType }) {
    const [form] = Form.useForm()

    const { Text, Title } = Typography

    const { TextArea } = Input

    const { Option } = Select

    const { Dragger } = Upload

    const { useToken } = theme
    const { token } = useToken()
    const dispatch = useDispatch()

    const {
        profileModal,
        formButtonType,
        selectedData,
        updatedDataStatus,
        modelType,
        masterDataDropDown,
        masterDataDropDownStatus,
        profileData,
    } = useSelector(profileState)
    const { userProfile } = useSelector(loginState)

    const formatDatePicker = (value) => {
        return `${dayjs(value).format('DD MMM YY')}`
    }

    const [skillsData, setSkillsData] = useState([])
    const [toolsData, setToolsData] = useState([])
    const [fileURL, setFileURL] = useState([])
    const [viewMediaModal, setViewMediaModal] = useState(false)
    const [checked, setChecked] = useState(false)
    const [suggestions, setSuggestions] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const timeoutRef = useRef()

    const sessionTokenRef = useRef()

    // ADD MASTER DATA
    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'company'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Page 1_1689584485.svg'
                                : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                        // limit: pageLimit,
                        // skip: skipPage,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // SEARCH MASTER DATA
    const searchFn = debounce((value, model) => {
        if (value?.length > 0) {
            dispatch(changeModel(model))
            dispatch(
                masterDataDropDownList({
                    search: value,
                    id: model,
                })
            )
        }
        setSearchValue(value)
    }, 800)

    // GOOGLE PLACE API INTEGRATION
    const loadSuggestions = async (inputValue) => {
        clearTimeout(timeoutRef.current)

        if (!inputValue || inputValue.trim().length <= 1) {
            setSuggestions([])
            return
        }

        timeoutRef.current = setTimeout(async () => {
            if (!sessionTokenRef.current) {
                sessionTokenRef.current =
                    new window.google.maps.places.AutocompleteSessionToken()
            }

            new window.google.maps.places.AutocompleteService().getPlacePredictions(
                {
                    input: inputValue,
                    sessionToken: sessionTokenRef.current,
                },
                (predictions, status) => {
                    if (
                        status ===
                        window.google.maps.places.PlacesServiceStatus
                            .ZERO_RESULTS
                    ) {
                        setSuggestions([])
                        return
                    }
                    if (
                        status !==
                            window.google.maps.places.PlacesServiceStatus.OK ||
                        !predictions
                    ) {
                        return
                    }
                    let newData =
                        predictions?.length > 0 &&
                        predictions.map((data) => {
                            return {
                                label: data?.description,
                                value: data?.description,
                            }
                        })
                    setSuggestions(newData)
                }
            )
        }, 350)
    }

    function onFinishFailed() {}

    // DISABLE START DATE
    const disabledDateEnd = (current) => {
        const startDate = form.getFieldValue('start')
        // Disable dates that are before the selected start date or dates that are in the past
        return startDate
            ? (current && current.valueOf() < startDate.valueOf()) ||
                  (current && current.valueOf() > Date.now())
            : current && current.valueOf() > Date.now()
    }

    // DISABLE END DATE
    const disabledDateStart = (current) => {
        const endDate = form.getFieldValue('end')
        // Disable dates that are after the selected end date or dates that are in the future
        return (
            (endDate && current && current.valueOf() > endDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
        )
    }

    // EDIT MODAL DATA SET INITIALLY
    useEffect(() => {
        if (selectedData) {
            if (selectedData?.currentlyWorking) {
                setChecked(true)
            }
            setSkillsData(
                selectedData?.skills?.length > 0
                    ? selectedData?.skills.map((data) => {
                          return {
                              label: data?.name,
                              value: data?._id,
                          }
                      })
                    : []
            )
            setToolsData(
                selectedData?.tools?.length > 0
                    ? selectedData?.tools.map((data) => {
                          return {
                              label: data?.name,
                              value: data?._id,
                              logo: data?.logo,
                          }
                      })
                    : []
            )
            if (selectedData?.fileLink?.length > 0) {
                setFileURL([selectedData?.fileLink])
            }

            const {
                _id: valueCompanyName,
                name: labelCompanyName,
                logo: logoCompanyName,
            } = {
                ...selectedData?.companyName,
            }

            const new_obj_company = Object.assign(
                {},
                {
                    label: labelCompanyName && (
                        <Space size={'large'}>
                            <div
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    padding: '8px 5px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: `1px solid ${token.colorPalette.textColor.quinary}`,
                                }}
                            >
                                {logoCompanyName ? (
                                    <Image
                                        src={logoCompanyName}
                                        height={'30px'}
                                        width={'30px'}
                                        preview={false}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                        }}
                                    >
                                        <CompanyDefaultIcon />
                                    </div>
                                )}
                            </div>
                            <Text>{labelCompanyName}</Text>
                        </Space>
                    ),
                    value: valueCompanyName,
                }
            )

            form.setFieldsValue({
                ...selectedData,
                employmentType: selectedData?.employmentType
                    ? [
                          {
                              label: selectedData?.employmentType?.name,
                              value: selectedData?.employmentType?._id,
                          },
                      ]
                    : [],
                companyName: selectedData?.companyName
                    ? [
                          {
                              ...new_obj_company,
                          },
                      ]
                    : [],
                start: selectedData?.start ? dayjs(selectedData?.start) : '',
                end: selectedData?.end ? dayjs(selectedData?.end) : '',
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, selectedData])

    // SAVE / SAVE AND ADD MORE / SAVE AS DRAFT EXPERIENCE
    async function onFinishExperience(value) {
        let modalState = { ...profileModal }

        if (formButtonType === 'draftButtonLoading') {
            if (
                Object.keys(value).every((item) => isEmpty(value[item])) &&
                skillsData?.length === 0 &&
                toolsData?.length === 0
            ) {
                message.info('Please Fill at-least one Field')
                form.resetFields()
                return
            }
        }

        dispatch(
            profileLoading({
                name: modalType,
                buttonName: formButtonType,
                loading: true,
            })
        )

        const extractValue = (input) => {
            if (Array.isArray(input)) {
                return input.map((item) => item?.value || item)
            } else if (input && typeof input === 'object') {
                return input.value || input._id || input
            }
            return input
        }
        const newExperienceEntry = {
            title: value?.title ? value?.title : null,
            employmentType: extractValue(value?.employmentType) || null,
            company: extractValue(value?.companyName) || null,
            location: value?.location || null,
            startDate: new Date(value?.start).getTime() || '',
            endDate: new Date(value?.end).getTime() || '',
            summary: value.summary,
            skills: extractValue(skillsData) || [],
            tools: extractValue(toolsData) || [],
            softSkills: extractValue(skillsData) || [],
            fileTitle: value.fileTitle,
            description: value.description,
            fileLink: fileURL?.length > 0 ? fileURL[0] : '',
            currentlyWorking: checked,
            isCompleted: formButtonType === 'draftButtonLoading' ? false : true,
        }

        let payload = {}

        if (selectedData) {
            newExperienceEntry._id = selectedData?._id
        }

        if (selectedData) {
            // Only send edited entry
            const existingExperience = profileData?.data?.experience || []
            const filteredExperience = existingExperience.filter(
                (edu) => edu._id !== selectedData?._id
            )

            payload = {
                experience: [...filteredExperience, newExperienceEntry],
                candidateId: userProfile?._id,
            }
        } else {
            // Append new entry to existing experience array
            const existingExperience = profileData?.data?.experience || []
            payload = {
                experience: [...existingExperience, newExperienceEntry],
                candidateId: userProfile?._id,
            }
        }

        const result = userProfile?.isCandidateUser
            ? await candidateEdit(
                  modalType?.toUpperCase(),
                  userProfile?._id,
                  payload
              )
            : await dispatch(
                  addSummary({
                      _id: userProfile?._id,
                      summary: {
                          step: modalType,
                          data: {
                              ...value,
                              companyName:
                                  typeof value.companyName === 'object'
                                      ? value.companyName[0]?.value
                                      : value.companyName,
                              employmentType:
                                  typeof value.employmentType === 'object'
                                      ? value.employmentType[0]?.value
                                      : value.employmentType,
                              fileLink: fileURL?.length > 0 ? fileURL[0] : '',
                              start: new Date(value?.start).getTime(),
                              end: !checked && new Date(value?.end).getTime(),
                              skills:
                                  skillsData?.length > 0
                                      ? skillsData.map((data) => data?.value)
                                      : [],
                              tools:
                                  toolsData?.length > 0
                                      ? toolsData.map((data) => data?.value)
                                      : [],
                              _id: selectedData && selectedData?._id,
                              isCompleted:
                                  formButtonType === 'draftButtonLoading'
                                      ? false
                                      : true,
                          },
                      },
                  })
              )
        const data = userProfile?.isCandidateUser
            ? result?.data
            : result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    profileLoading({
                        name: modalType,
                        buttonName: formButtonType,
                        loading: false,
                    })
                )
                if (formButtonType === 'addMoreButtonLoading') {
                    form.resetFields()
                    setSkillsData([])
                    setToolsData([])
                    setFileURL([])
                    dispatch(
                        switchProfileModal({ name: 'experience', open: true })
                    )
                } else {
                    dispatch(
                        switchProfileModal({ name: 'experience', open: false })
                    )
                }
                dispatch(updateUserGet({ _id: userProfile?._id }))
                message.success(errorMessage)
            } else {
                dispatch(switchProfileModal(modalState))
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // ONCHANGE FILE PROPS
    const props = {
        name: 'fileLink',
        multiple: false,
        onChange(info) {
            // setStream(true)

            const nameChange = info?.fileList[0]?.name
                .split('.')[0]
                .concat(`_${dayjs(new Date()).unix()}`)
                .concat(`.${info?.fileList[0]?.name.split('.')[1]}`)

            const newFileData = new File(
                [info?.fileList[0]?.originFileObj],
                nameChange,
                { type: info?.fileList[0]?.type }
            )
            window.Buffer = window.Buffer || require('buffer').Buffer

            S3FileUpload.uploadFile(newFileData, userProfile?.s3Config)
                .then(async (data) => {
                    // fileUpload.push(data?.location)
                    setFileURL([data?.location])
                })
                .catch(() => {
                    message.error('Upload Failed!. Please Upload again')
                })
        },

        beforeUpload() {
            return false
        },

        onDrop() {},
    }

    // COLLAPSE HEADER
    const CollapseLabel = ({ name, icon, description }) => (
        <Row
            align={'middle'}
            style={{
                columnGap: '20px',
                marginBottom: '18px',
            }}
        >
            <Row
                style={{
                    height: '50px',
                    width: '50px',
                    borderRadius: '10px',
                    padding: '12px',
                    backgroundColor: token.colorPalette.baseColor.tertiary,
                }}
                align={'middle'}
                justify={'center'}
            >
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px',
                    }}
                >
                    {icon}
                </div>
            </Row>
            <div>
                <Title
                    style={{
                        fontSize: token.fontSizeHeading4,
                    }}
                >
                    {name}
                </Title>
                <Text className="sub-title">{description}</Text>
            </div>
        </Row>
    )

    // COLLAPSE ITEMS
    const getItems = () => [
        {
            key: '1',
            label: (
                <CollapseLabel
                    name={`Add Skills ${
                        skillsData?.length > 0 ? `(${skillsData?.length})` : ''
                    }`}
                    icon={
                        <SkillsIcon
                            color={token.colorPalette.baseColor.white}
                        />
                    }
                    description="Please add the skills suitable to your expertise."
                />
            ),
            children: (
                <>
                    {/* <SelectTags
                        placeholder={'Search Skills'}
                        options={skillsData?.length > 0 ? skillsData : []}
                        value={skillsData}
                        handleChange={(e) => {
                            const trimSkills = e.trimStart()
                            if (trimSkills?.length > 0) {
                                setSkillsData([
                                    ...skillsData,
                                    { label: trimSkills, value: trimSkills },
                                ])
                            }
                        }}
                        handleRemove={(e) => {
                            const removeData = [...skillsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setSkillsData(removeData)
                        }}
                    /> */}
                    <Select
                        placeholder="Search Skills"
                        showSearch
                        onSearch={(value) => {
                            searchFn(value, MASTER_DATA_FIELD.skills)
                        }}
                        tagRender={() => null}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setSkillsData([
                                    ...skillsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        onDeselect={(e) => {
                            const removeData = [...skillsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setSkillsData(removeData)
                        }}
                        style={{
                            width: '100%',
                        }}
                        mode="multiple"
                        rootClassName={[
                            'p-0-multiSelect',
                            skillsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        filterOption={false}
                        allowClear={false}
                        dropdownRender={(menu) => (
                            <DropDownMultiple
                                menu={menu}
                                searchValue={searchValue}
                                name={MASTER_DATA_FIELD.skills}
                                addMasterData={() => addMasterData()}
                            />
                        )}
                    >
                        {masterDataDropDown?.skills?.length > 0 &&
                        masterDataDropDownStatus === 'loaded'
                            ? masterDataDropDown?.skills.map((option) => {
                                  return (
                                      <Option
                                          key={option?.label}
                                          value={option?.value}
                                      >
                                          <Text>{option?.label}</Text>
                                      </Option>
                                  )
                              })
                            : masterDataDropDownStatus === 'loading' && (
                                  <Spin></Spin>
                              )}
                    </Select>
                    <div
                        style={{
                            marginTop: '30px',
                        }}
                    >
                        <Text>My Skills</Text>
                        <Card
                            style={{
                                border: `2px dashed ${token.colorPalette.textColor.quaternary}`,
                                margin: '4px 0px 14px 0px',
                                padding: '0px',
                                minHeight: '110px',
                            }}
                            styles={{
                                body: {
                                    padding: '15px',
                                },
                            }}
                        >
                            <Row style={{ rowGap: '10px' }}>
                                {skillsData?.length > 0 &&
                                    skillsData.map((skill, index) => (
                                        <Tag
                                            style={{
                                                padding: '10px 20px',
                                                whiteSpace: 'normal',
                                                overflow: 'hidden',
                                            }}
                                            color={
                                                token.colorPalette.baseColor
                                                    .tertiary
                                            }
                                        >
                                            <Row
                                                align={'middle'}
                                                style={{
                                                    columnGap: '30px',
                                                }}
                                            >
                                                <Text
                                                    style={{
                                                        color: token
                                                            .colorPalette
                                                            .baseColor.white,
                                                    }}
                                                >
                                                    {skill?.label?.toUpperCase()}
                                                </Text>
                                                <div
                                                    style={{
                                                        width: '13px',
                                                    }}
                                                    onClick={() => {
                                                        const removeData = [
                                                            ...skillsData,
                                                        ]
                                                        removeData.splice(
                                                            index,
                                                            1
                                                        )
                                                        setSkillsData(
                                                            removeData
                                                        )
                                                    }}
                                                >
                                                    <CrossIcon />
                                                </div>
                                            </Row>
                                        </Tag>
                                    ))}
                            </Row>
                        </Card>
                    </div>
                </>
            ),
        },
        {
            key: '2',
            label: (
                <CollapseLabel
                    name={`Add Tools ${
                        toolsData?.length > 0 ? `(${toolsData?.length})` : ''
                    }`}
                    icon={
                        <ToolsIcon color={token.colorPalette.baseColor.white} />
                    }
                    description="Please add tools suitable to your hands-on experience."
                />
            ),
            children: (
                <>
                    {/* <SelectTags
                        placeholder={'Search Tools'}
                        options={toolsData?.length > 0 ? toolsData : []}
                        value={toolsData}
                        handleChange={(e) => {
                            const trimTools = e.trimStart()
                            if (trimTools?.length > 0) {
                                setToolsData([
                                    ...toolsData,
                                    {
                                        label: trimTools,
                                        value: trimTools,
                                        logo: 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg',
                                    },
                                ])
                            }
                        }}
                        handleRemove={(e) => {
                            const removeData = [...toolsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setToolsData(removeData)
                        }}
                    /> */}
                    <Select
                        placeholder="Search Tools"
                        showSearch
                        onSearch={(value) => {
                            searchFn(value, MASTER_DATA_FIELD.tools)
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        tagRender={() => null}
                        onSelect={(e, options) => {
                            const key = JSON.parse(options?.key)
                            const trimTools = key?.label.trimStart()
                            if (trimTools?.length > 0) {
                                setToolsData([
                                    ...toolsData,
                                    {
                                        label: trimTools,
                                        value: e,
                                        logo: key?.logo,
                                    },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...toolsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setToolsData(removeData)
                        }}
                        style={{
                            width: '100%',
                        }}
                        mode="multiple"
                        rootClassName={[
                            'p-0-multiSelect',
                            toolsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        filterOption={false}
                        allowClear={false}
                        dropdownRender={(menu) => (
                            <DropDownMultiple
                                menu={menu}
                                searchValue={searchValue}
                                name={MASTER_DATA_FIELD.tools}
                                addMasterData={() => addMasterData()}
                            />
                        )}
                    >
                        {masterDataDropDown?.tools?.length > 0 &&
                        masterDataDropDownStatus === 'loaded'
                            ? masterDataDropDown?.tools.map((option) => {
                                  return (
                                      <Option
                                          key={JSON.stringify({
                                              label: option?.label,
                                              logo: option?.logo,
                                          })}
                                          value={option?.value}
                                          children={option?.logo}
                                      >
                                          <Space size={'large'}>
                                              {option?.logo ? (
                                                  <Image
                                                      src={option?.logo}
                                                      height={'30px'}
                                                      width={'30px'}
                                                      preview={false}
                                                  />
                                              ) : (
                                                  <div
                                                      style={{
                                                          width: '30px',
                                                          height: '30px',
                                                      }}
                                                  >
                                                      <ToolsIcon />
                                                  </div>
                                              )}
                                              <Text>{option?.label}</Text>
                                          </Space>
                                      </Option>
                                  )
                              })
                            : masterDataDropDownStatus === 'loading' && (
                                  <Spin></Spin>
                              )}
                    </Select>
                    <div
                        style={{
                            marginTop: '30px',
                        }}
                    >
                        <Text>My Tools</Text>
                        <Card
                            style={{
                                border: `2px dashed ${token.colorPalette.textColor.quaternary}`,
                                marginTop: '4px',
                                padding: '0px',
                                minHeight: '110px',
                            }}
                            styles={{
                                body: {
                                    padding: '15px',
                                },
                            }}
                        >
                            <Row style={{ rowGap: '10px' }}>
                                <Row
                                    style={{
                                        columnGap: '15px',
                                    }}
                                >
                                    {toolsData?.length > 0 &&
                                        toolsData.map((tool, index) => (
                                            <div>
                                                <div
                                                    className={
                                                        styles.toolIconDefault
                                                    }
                                                    style={{
                                                        border: `2px solid ${token.colorPalette.baseColor.tertiary}`,
                                                    }}
                                                >
                                                    <ToolsIcon
                                                        color={
                                                            token.colorPalette
                                                                .baseColor
                                                                .tertiary
                                                        }
                                                    />
                                                    <div
                                                        className={
                                                            styles.toolsIconCross
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                token
                                                                    .colorPalette
                                                                    .baseColor
                                                                    .tertiary,
                                                        }}
                                                        onClick={() => {
                                                            const removeData = [
                                                                ...toolsData,
                                                            ]
                                                            removeData.splice(
                                                                index,
                                                                1
                                                            )
                                                            setToolsData(
                                                                removeData
                                                            )
                                                        }}
                                                    >
                                                        <Row
                                                            style={{
                                                                height: '100%',
                                                                width: '100%',
                                                            }}
                                                        >
                                                            <CrossIcon />
                                                        </Row>
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        width: '60px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow:
                                                            'ellipsis',
                                                    }}
                                                >
                                                    <Text
                                                        style={{
                                                            marginTop: '2px',
                                                            fontWeight:
                                                                token.fontWeightStrong,
                                                            textTransform:
                                                                'capitalize',
                                                        }}
                                                    >
                                                        {tool?.label}
                                                    </Text>
                                                </div>
                                            </div>
                                        ))}
                                </Row>
                            </Row>
                        </Card>
                    </div>
                </>
            ),
        },
        {
            key: '3',
            label: (
                <CollapseLabel
                    name="Add Media"
                    icon={
                        <VideosIcon
                            color={token.colorPalette.baseColor.white}
                        />
                    }
                />
            ),
            children: (
                <Row
                    style={{
                        overflowX: 'hidden',
                    }}
                    justify={'space-between'}
                    gutter={16}
                >
                    <Col span={12}>
                        {fileURL?.length > 0 ? (
                            <Card
                                style={{
                                    minHeight: '185px',
                                    padding: 0,
                                    position: 'relative',
                                }}
                                styles={{
                                    body: {
                                        padding: 0,
                                    },
                                }}
                            >
                                {/* <Image
                                    src={fileURL[0]}
                                    height="185px"
                                    width={'100%'}
                                    style={{
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        // opacity: '50%',
                                    }}
                                    preview={false}
                                /> */}
                                <video
                                    src={fileURL[0]}
                                    width={'100%'}
                                    height={'185px'}
                                    style={{
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                    }}
                                    preview={false}
                                />
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45%',
                                        right: '45%',
                                        cursor: 'pointer',
                                        height: '30px',
                                        width: '30px',
                                    }}
                                    onClick={() => setViewMediaModal(true)}
                                >
                                    <PreviewIcon />
                                </div>
                            </Card>
                        ) : (
                            <Form.Item
                                name={'fileLink'}
                                className="fileDragger"
                            >
                                <Dragger
                                    {...props}
                                    fileList={[]}
                                    previewFile={false}
                                    style={{
                                        border: `2px dashed ${token.colorPalette.textColor.quaternary}`,
                                        padding: '20px',
                                        height: '185px',
                                    }}
                                    accept=".MP4,.MOV,.WMV,.AVI,.AVCHD,.FLV,.F4V,.SWF,.MKV,.WEBM,.HTML5"
                                >
                                    <Text className="titleSecondary">
                                        Click or Drag
                                    </Text>
                                    <br />
                                    <Text className="titleSecondary">
                                        File to Upload
                                    </Text>
                                </Dragger>
                            </Form.Item>
                        )}
                        <Button
                            props={{
                                text: 'Remove File',
                                disabled: fileURL?.length === 0 && true,
                                onClick: () => setFileURL([]),
                                style: {
                                    width: '100%',
                                    marginTop: '25px',
                                },
                            }}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item name={'fileTitle'} label="Title">
                            <Input
                                placeholder="Enter Title"
                                style={{
                                    marginBottom: '27px',
                                }}
                                onChange={(e) => {
                                    form.setFieldValue(
                                        'fileTitle',
                                        e.target.value.trimStart()
                                    )
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            name={'description'}
                            label="Description"
                            rules={[
                                {
                                    max: 250,
                                    min: 10,
                                    message:
                                        'Description should be minimum 10 and maximum 250 characters long',
                                },
                            ]}
                        >
                            <TextArea
                                rows={5}
                                placeholder={'Enter Description...'}
                                name={'description'}
                                onChange={(e) => {
                                    form.setFieldValue(
                                        'description',
                                        e.target.value.trimStart()
                                    )
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            ),
        },
    ]

    return updatedDataStatus === 'loading' ? (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}
        >
            <Spin size="large" />
        </div>
    ) : (
        <>
            <Form
                layout="vertical"
                labelCol={{
                    style: {
                        padding: '0 0 3px',
                    },
                }}
                name="addExperience"
                onFinish={onFinishExperience}
                onFinishFailed={onFinishFailed}
                requiredMark={false}
                onSubmitCapture={async (e) => {
                    // if (e.nativeEvent.submitter.id === 'draftButtonLoading') {
                    //     form.resetFields()
                    // }
                    await dispatch(checkButtonType(e.nativeEvent.submitter.id))
                }}
                form={form}
                style={{
                    marginBottom: '20px',
                    overflowX: 'hidden',
                }}
            >
                <Row
                    style={{
                        rowGap: '20px',
                    }}
                    justify={'space-between'}
                    gutter={16}
                >
                    <Col span={12}>
                        <Form.Item
                            label="Title*"
                            name="title"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                          {
                                              required: true,
                                              message: 'Please Enter Title',
                                          },
                                          {
                                              max: 50,
                                              message:
                                                  'Title should be maximum 50 characters long',
                                          },
                                      ]
                                    : []
                            }
                            colon={false}
                        >
                            <Input
                                name="title"
                                placeholder="Enter Title"
                                onChange={(e) => {
                                    form.setFieldValue(
                                        'title',
                                        e.target.value.trimStart()
                                    )
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Employment Type*"
                            name={MASTER_DATA_FIELD.employmentType}
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                          {
                                              required: true,
                                              message:
                                                  'Please Select Employment Type',
                                          },
                                      ]
                                    : []
                            }
                            colon={false}
                        >
                            {/* <Select
                                placeholder="Select Employment Type"
                                allowClear={false}
                                options={employmentTypeList}
                            ></Select> */}
                            <Select
                                placeholder="Search a Employment Type"
                                showSearch
                                onSearch={(value) => {
                                    dispatch(
                                        changeModel(
                                            MASTER_DATA_FIELD.employmentType
                                        )
                                    )
                                    searchFn(
                                        value,
                                        MASTER_DATA_FIELD.employmentType
                                    )
                                }}
                                filterOption={false}
                                allowClear={false}
                                dropdownRender={(menu) => (
                                    <DropDownMultiple
                                        menu={menu}
                                        searchValue={searchValue}
                                        name={MASTER_DATA_FIELD.employmentType}
                                        addMasterData={() => addMasterData()}
                                    />
                                )}
                                getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                }
                            >
                                {masterDataDropDown?.employmentType?.length >
                                    0 && masterDataDropDownStatus === 'loaded'
                                    ? masterDataDropDown?.employmentType.map(
                                          (option) => {
                                              return (
                                                  <Option
                                                      key={option?.value}
                                                      value={option?.value}
                                                  >
                                                      <Text>
                                                          {option?.label}
                                                      </Text>
                                                  </Option>
                                              )
                                          }
                                      )
                                    : masterDataDropDownStatus ===
                                          'loading' && <Spin></Spin>}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name={'companyName'}
                            label="Company Name*"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                          {
                                              required: true,
                                              message:
                                                  'Please Enter Company Name',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <Select
                                placeholder="Search Company Name"
                                showSearch
                                onSearch={(value) => {
                                    dispatch(
                                        changeModel(MASTER_DATA_FIELD.company)
                                    )
                                    searchFn(value, MASTER_DATA_FIELD.company)
                                }}
                                filterOption={false}
                                allowClear={false}
                                dropdownRender={(menu) => (
                                    <DropDownMultiple
                                        menu={menu}
                                        searchValue={searchValue}
                                        name={MASTER_DATA_FIELD.company}
                                        addMasterData={() => addMasterData()}
                                    />
                                )}
                                getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                }
                            >
                                {masterDataDropDown?.company?.length > 0 &&
                                masterDataDropDownStatus === 'loaded'
                                    ? masterDataDropDown?.company.map(
                                          (option) => {
                                              return (
                                                  <Option
                                                      key={option?.value}
                                                      value={option?.value}
                                                  >
                                                      <Space size={'large'}>
                                                          <div
                                                              style={{
                                                                  width: '30px',
                                                                  height: '30px',
                                                                  padding:
                                                                      '8px 5px',
                                                                  display:
                                                                      'flex',
                                                                  alignItems:
                                                                      'center',
                                                                  justifyContent:
                                                                      'center',
                                                                  border: `1px solid ${token.colorPalette.textColor.quinary}`,
                                                              }}
                                                          >
                                                              {option?.logo ? (
                                                                  <Image
                                                                      src={
                                                                          option?.logo
                                                                      }
                                                                      height={
                                                                          '30px'
                                                                      }
                                                                      width={
                                                                          '30px'
                                                                      }
                                                                      preview={
                                                                          false
                                                                      }
                                                                  />
                                                              ) : (
                                                                  <div
                                                                      style={{
                                                                          width: '30px',
                                                                          height: '30px',
                                                                      }}
                                                                  >
                                                                      <CompanyDefaultIcon />
                                                                  </div>
                                                              )}
                                                          </div>
                                                          <Text>
                                                              {option?.label}
                                                          </Text>
                                                      </Space>
                                                  </Option>
                                              )
                                          }
                                      )
                                    : masterDataDropDownStatus ===
                                          'loading' && <Spin></Spin>}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Location*"
                            name="location"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                          {
                                              required: true,
                                              message: 'Please Select Location',
                                          },
                                      ]
                                    : []
                            }
                            colon={false}
                        >
                            <Select
                                placeholder="Search a Location"
                                allowClear={false}
                                onSearch={(value) => {
                                    loadSuggestions(value)
                                }}
                                notFoundContent={
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No Locations Searched"
                                    ></Empty>
                                }
                                showSearch
                                options={suggestions}
                                getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Start Date*"
                            colon={false}
                            name={'start'}
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                          {
                                              required: true,
                                              message:
                                                  'Please Select Start Date',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <DatePicker
                                allowClear={false}
                                name="start"
                                disabledDate={disabledDateStart}
                                format={formatDatePicker}
                                // getPopupContainer={(trigger) =>
                                //     trigger.parentNode
                                // }
                                getPopupContainer={() => document.body}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="End Date*"
                            colon={false}
                            name={'end'}
                            rules={
                                formButtonType !== 'draftButtonLoading' &&
                                !checked
                                    ? [
                                          {
                                              required: true,
                                              message: 'Please Select End Date',
                                          },
                                      ]
                                    : []
                            }
                        >
                            <DatePicker
                                allowClear={false}
                                name="end"
                                disabled={checked}
                                disabledDate={disabledDateEnd}
                                format={formatDatePicker}
                                // getPopupContainer={(trigger) =>
                                //     trigger.parentNode
                                // }
                                getPopupContainer={() => document.body}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Summary*"
                            name="summary"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                          {
                                              required: true,
                                              message: 'Please Enter Summary',
                                          },
                                          {
                                              min: 8,
                                              max: 250,
                                              message:
                                                  'Summary is minimum 8 and maximum 250 characters long',
                                          },
                                      ]
                                    : []
                            }
                            colon={false}
                        >
                            <TextArea
                                rows={4}
                                placeholder={'Enter Summary...'}
                                name={'summary'}
                                onChange={(e) => {
                                    form.setFieldValue(
                                        'summary',
                                        e.target.value.trimStart()
                                    )
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item
                            name="currentlyWorking"
                            valuePropName="checked"
                        >
                            <Checkbox
                                onChange={(e) => {
                                    const isChecked = e.target.checked
                                    setChecked(isChecked)
                                    if (isChecked) {
                                        // Clear errors only when the checkbox is checked
                                        form.setFields([
                                            {
                                                name: 'end',
                                                errors: [],
                                            },
                                        ])
                                    }

                                    // Optionally set the value of 'end' to an empty string or null
                                    form.setFieldValue(
                                        'end',
                                        isChecked ? '' : null
                                    )
                                }}
                            >
                                I am currently working in this role
                            </Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Collapse
                    bordered={false}
                    defaultActiveKey={['1', '2', '3']}
                    expandIcon={({ isActive }) => {
                        return <ExpandIcon isActive={!isActive} />
                    }}
                    expandIconPosition="right"
                    style={{
                        backgroundColor: 'transparent',
                    }}
                    items={getItems()}
                />
            </Form>
            <ModalProfile
                visibility={viewMediaModal}
                handleCancel={() => {
                    setViewMediaModal(false)
                }}
                footer={false}
                icon={<ExperienceIcon />}
                modalKey="viewVideo"
                modalTitle="Media"
                showTitle="Media"
                content={
                    <ViewMediaModal
                        fileName={fileURL?.length > 0 && fileURL[0]}
                    />
                }
            />
        </>
    )
}

export default ExperienceModal
